export default [
	{ cnpj: '00063960049450', nome: 'Prati,Donaduzzi & Cia Ltda' },
	{ cnpj: '00063960049452', nome: 'NAZARIA DIST.DE PRODUTOS FARM.LTDA' },
	{ cnpj: '00063960049453', nome: 'EMIS MINAS DIST. PROD. FARMACEUTICOS LTD' },
	{ cnpj: '00063960049451', nome: 'UTIL FARMA DIST. DE MED. HOSPITALARLTDA' },
	{ cnpj: '00063960049457', nome: 'ACRIPEL DISTRIBUIDORA PE LTDA' }
];
